module.exports = __webpack_public_path__ + "src/assets/img/m-item4.19c42810.png";